export { default as Add } from './add';
export { default as Comment } from './comment';
export { default as Delete } from './delete';
export { default as Download } from './download';
export { default as Edit } from './edit';
export { default as Remove } from './remove';
export { default as Share } from './share';



// WEBPACK FOOTER //
// ./src/icon/svgs/interaction/index.js